export const RouteErrorPage = {
  title: "This page didn't load",
  description: 'Something went wrong while loading this page. Reload to try again, or go to the home page.',
  reloadLabel: 'Reload page',
  homeLinkLabel: 'Go to the home page',
};